exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-info-circle[data-v-28cd0bab]{color:#ed1763;margin-right:1em;cursor:pointer}.btn-reset[data-v-28cd0bab]{margin-right:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28cd0bab","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CropImageModal.vue
// module id = +huf
// module chunks = 101